import { render, staticRenderFns } from "./EditTaxPage.vue?vue&type=template&id=9b01b288"
import script from "./EditTaxPage.vue?vue&type=script&lang=js"
export * from "./EditTaxPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports